import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMClickOutsideObserver from 'lib/SMClickOutsideObserver';
import OptimizedImage from 'components/shared/OptimizedImage';

class SMSearchOwnerBaloonView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isHover: false,
    };
    this.isEnter = false;
  }

  componentDidMount() {
    this.clickOutsideObserver = new SMClickOutsideObserver(this);
    this.clickOutsideObserver.attach(()=>{
      // this.hideBaloon();
    });
  }

  componentWillUnmount() {
    this.clickOutsideObserver.detach();
  }

  iconDidMouseEnter() {
    this.setState({isHover: true});
  }

  iconDidMouseLeave() {
    setTimeout(()=>{
      if (!this.isEnter) {
        this.hideBaloon();
      }
    }, 300);
  }

  enterBaloon() {
    this.isEnter = true;
  }

  hideBaloon() {
    this.isEnter = false;
    this.setState({isHover: false});
  }

  render() {

    const room = this.props.room;
    const owner = room.owner;
    const baloonStyle = this.props.showBaloon && this.state.isHover ? {} : {display: "none"};
    let goldSuperHost = null;
    if (owner.rank && owner.rank == SMConst.OwnerRank.SuperHost) {
      goldSuperHost = <div className="mod-host__icon-inner"><img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" className="units-item__body-superhost" /></div>;
    }

    let authRows = [];
    if (owner.is_verified_email) {
      authRows.push(<p key="email" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000095")}</p>);
    }
    if (owner.is_verified_tel) {
      authRows.push(<p key="tel" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000096")}</p>);
    }

    return(
      <div>
        <div className="units-item__body-thumb">
          <a target="_blank" href={Routes.owner_path(owner.username)}>
            <OptimizedImage
              src={owner.profile_image}
              alt={SMFormatHelper.ownerName(owner)}
              imageDidMouseEnter={this.iconDidMouseEnter.bind(this)}
              imageDidMouseLeave={this.iconDidMouseLeave.bind(this)}
            />
          </a>
        </div>
        {goldSuperHost}
        <div style={baloonStyle}
          onMouseEnter={this.enterBaloon.bind(this)}
          onMouseLeave={this.hideBaloon.bind(this)}
          className="baloon user-detail-baloon units-baloon">
          <div className="baloon-inner">
            <OptimizedImage
              src={owner.profile_image}
              alt={SMFormatHelper.ownerName(owner)}
              className="user-detail-baloon__img"
            />
            <p className="user-detail-baloon__name">{SMFormatHelper.ownerName(owner)}</p>
            {authRows}
            <a href={Routes.owner_path(owner.username)} target="_blank" className="button-blue user-detail-baloon__button">詳しいプロフィール</a>
          </div>
        </div>
      </div>
    );
  }

}
export default SMSearchOwnerBaloonView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchOwnerBaloonView.jsx